var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    width: 50,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M209.92 20.48H46.08c-14.131 0-25.6 11.469-25.6 25.6v163.84c0 14.131 11.469 25.6 25.6 25.6h163.84c14.131 0 25.6-11.469 25.6-25.6V46.08c0-14.131-11.469-25.6-25.6-25.6zm-20.48 76.8H179.2c-10.957 0-15.36 2.56-15.36 10.24v15.36h25.6l-5.12 25.6h-20.48v76.8h-25.6v-76.8h-20.48v-25.6h20.48v-15.36c0-20.48 10.24-35.84 30.72-35.84 14.848 0 20.48 5.12 20.48 5.12z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.1c32e0366497f4cbc36b7b0031d77bd6.svg";
export { ForwardRef as ReactComponent };